module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-14-4f9246d7decfb19288c3d61bb7230d3c.jpg";